<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-editor-full`]" width="1em" height="1em" v-bind="$attrs"><path d="M55.217916,23.6771571 L84.453084,52.8060243 L29.057292,108.000071 L6.035958,108.000071 C2.8539108,108.000071 0.24697548,105.546624 0.016555428,102.434836 L0,101.986006 L0,79.048433 L55.217916,23.6771571 Z M85.119552,1.41014957 L85.514616,1.77263554 L106.243272,22.5345827 C108.58968,24.8849415 108.58536,28.6842326 106.232148,31.0284578 L104.000544,33.2485041 L104.041044,33.2892873 L92.987892,44.2992363 L63.719568,15.1402391 L72.767484,6.05911875 L72.71046,6.00284013 L76.967388,1.7614659 C79.200504,-0.463543263 82.748088,-0.580650141 85.119552,1.41014957 Z" transform="translate(11 11)" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmEditorFull',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
